(() => {
  const bind = () => {
    const menu = document.querySelector('.ev-menu');
    if (!menu || menu.dataset.evaMenuBound === 'true') return;
    menu.dataset.evaMenuBound = 'true';

    const summary = menu.querySelector(':scope > summary');
    const panel = menu.querySelector('.ev-menu__panel');
    if (!summary || !panel) return;

    const setBodyState = () => {
      document.body.classList.toggle('eva-mobile-menu-open', menu.open);
      summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    };

    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-controls', 'eva-mobile-menu-panel');
    summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
    panel.id = 'eva-mobile-menu-panel';

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      menu.open = !menu.open;
      setBodyState();
    }, { passive: false });

    menu.addEventListener('toggle', setBodyState);

    panel.addEventListener('click', (event) => {
      const link = event.target.closest('a');
      if (!link) return;
      menu.open = false;
      setBodyState();
    });

    document.addEventListener('click', (event) => {
      if (!menu.open || menu.contains(event.target)) return;
      menu.open = false;
      setBodyState();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        setBodyState();
        summary.focus();
      }
    });

    window.addEventListener('pageshow', setBodyState);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
